import { NgModule } from '@angular/core';
import {
  LucideAngularModule,
  Home,
  User,
  Bell,
  FolderCog,
  ChevronDown,
  Edit,
  FileText,
  HelpCircle,
  Info,
  LogOut,
  Menu,
  Plus,
  Search,
  Settings,
  Star,
  Hammer,
  Wrench,
  Pencil,
  Trash2,
  Fullscreen,
  CircleX,
  CircleGauge,
  Gauge,
  LayoutDashboard,
  Bug,
  Flag,
  Activity,
  HandCoins,
  CircleDollarSign,
  Landmark,
  ListPlus,
  FileClock,
  PanelsTopLeft,
  Library,
  BookText,
  Eye,
  Loader,
  Save,
  Replace,
  X,
  RectangleEllipsis,
  BookDashed,
  Inbox,
  ArrowLeftToLine,
  ArrowRightToLine,
  ArrowUp,
  ArrowDown,
  Filter,
  XCircle,
  CheckCircle,
  Undo2,
  Undo,
  CalendarCog,
  AlertCircle,
  ChevronLeft,
  Check,
  GitPullRequestDraft,
  Combine,
  History,
  GitPullRequestCreateArrow,
  NotebookTabs,
  FileX,
  Image,
  Eraser,
  DatabaseBackup,
  Boxes,
  ChevronRight,
  Lock,
  LockOpen,
  ListX,
  Loader2,
  RefreshCw,
  Clock,
  LayoutGrid,
  ZoomIn,
  ZoomOut,
  TrendingUp,
  AlertTriangle,
  Shield,
  Building2,
  Calendar,
  Target,
  PieChart,
  BarChart3,
  LineChart,
  AreaChart,
  FileSpreadsheet,
  FileCheck,
  FileSearch,
  Briefcase,
  Wallet,
  CreditCard,
  CalendarClock,
  Timer,
  SlidersHorizontal,
  Pin,
  MapPin,
  Map,
  MapPinPlus,
  MapPinHouse,
  MapPinned,
  FolderKanban,
  SquareKanban,
  Newspaper,
  ExternalLink,
  StickyNote,
  Award,
  Gavel,
  ChevronUp,
  FileBox,
  Edit3,
  Folder,
  FoldVertical,
  UnfoldVertical,
  MinusSquare,
  PlusSquare,
  PanelTopClose,
  PanelTopOpen,
  ChevronsDown,
  ChevronsUp,
  ChevronsUpDown,
  Maximize2,
  Minimize2,
  FolderOpen,
  Megaphone,
  BookMarked,
  FileQuestion,
  UserCheck,
  Link,
  MessageCircleQuestion,
  List,
  Circle,
  CheckCircle2,
  RotateCcw,
  Database,
  ServerCrash,
  Mail,
  Send,
  MessageSquare,
  MessageCircle,
  Users,
  UserPlus,
  UserCog,
  FolderPlus,
  FilePlus,
  ClipboardList,
  ClipboardCheck,
  Archive,
  Package,
  Compass,
  Navigation,
  Banknote,
  Scale,
  Camera,
  Video,
  Headphones,
  Mic,
  BookOpen,
  GraduationCap,
  Heart,
  Bookmark,
  Sparkles,
  Zap,
  Layers,
  Table,
  Presentation
} from 'lucide-angular';


@NgModule({
  imports: [
    LucideAngularModule.pick({
      Home,
      User,
      Settings,
      Bell,
      FileText,
      LogOut,
      Menu,
      Hammer,
      ChevronDown,
      FolderCog,
      Wrench,
      Info,
      Star,
      Search,
      Plus,
      Edit,
      HelpCircle,
      Pencil,
      Trash2,
      Fullscreen,
      CircleX,
      CircleGauge,
      Gauge,
      LayoutDashboard,
      Bug,
      Flag,
      Activity,
      HandCoins,
      CircleDollarSign,
      Landmark,
      ListPlus,
      FileClock,
      PanelsTopLeft,
      Library,
      BookText,
      Eye,
      Loader,
      Save,
      Replace,
      RectangleEllipsis,
      X,
      BookDashed,
      Inbox,
      ArrowLeftToLine,
      ArrowRightToLine,
      ArrowUp,
      ArrowDown,
      Filter,
      CheckCircle,
      XCircle,
      Undo2,
      Undo,
      CalendarCog,
      AlertCircle,
      ChevronLeft,
      Check,
      GitPullRequestDraft,
      Combine,
      History,
      GitPullRequestCreateArrow,
      NotebookTabs,
      FileX,
      Image,
      Eraser,
      DatabaseBackup,
      Boxes,
      ChevronRight,
      Lock,
      LockOpen,
      ListX,
      Loader2,
      RefreshCw,
      Clock,
      LayoutGrid,
      ZoomIn,
      ZoomOut,
      TrendingUp,
      AlertTriangle,
      Shield,
      Building2,
      Calendar,
      Target,
      PieChart,
      BarChart3,
      LineChart,
      AreaChart,
      FileSpreadsheet,
      FileCheck,
      FileSearch,
      Briefcase,
      Wallet,
      CreditCard,
      CalendarClock,
      Timer,
      SlidersHorizontal,
      Pin,
      MapPin,
      MapPinPlus,
      MapPinHouse,
      MapPinned,
      Map,
      FolderKanban,
      SquareKanban,
      Newspaper,
      ExternalLink,
      StickyNote,
      Award,
      Gavel,
      ChevronUp,
      FileBox,
      Edit3,
      Folder,
      UnfoldVertical,
      FoldVertical,
      MinusSquare,
      PlusSquare,
      PanelTopOpen,
      PanelTopClose,
      ChevronsUpDown,
      ChevronsUp,
      ChevronsDown,
      Maximize2,
      Minimize2,
      FolderOpen,
      Megaphone,
      BookMarked,
      FileQuestion,
      Link,
      UserCheck,
      MessageCircleQuestion,
      List,
      Circle,
      CheckCircle2,
      RotateCcw,
      Database,
      ServerCrash,
      Mail,
      Send,
      MessageSquare,
      MessageCircle,
      Users,
      UserPlus,
      UserCog,
      FolderPlus,
      FilePlus,
      ClipboardList,
      ClipboardCheck,
      Archive,
      Package,
      Compass,
      Navigation,
      Banknote,
      Scale,
      Camera,
      Video,
      Headphones,
      Mic,
      BookOpen,
      GraduationCap,
      Heart,
      Bookmark,
      Sparkles,
      Zap,
      Layers,
      Table,
      Presentation,
    }),
  ],
  exports: [LucideAngularModule],
  declarations: [],
  providers: [],
})
export class LucideIconsModule { }
